<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('leave_apply_scheme') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i
                    class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}
            </button>
            <router-link to="/leave" class="btn btn-outline-primary btn-sm no-bor"><i
                    class="fa fa-plus-circle"></i> {{$t('new')}}
            </router-link>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th class="text-center">{{$t('no')}}</th>
                                <th>{{$t('employee_num')}}</th>
                                <th>{{$t('khmer_name')}}</th>
                                <th>{{$t('latin_name')}}</th>
                                <th>{{$t('leave_scheme')}}</th>
                                <th class="text-center">{{$t('last_change_date')}}</th>
                                <th class="text-center" style="width: 80px;">{{$t('status')}}</th>
                                <th style="width: 60px">{{$t('balance')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><a href="javascript:void(0)" @click="schemeChange(ret)">{{ret.Employee.Num}}</a></td>
                                <td>{{ret.Employee.KhmerName}}</td>
                                <td>{{ret.Employee.LatinName}}</td>
                                <td>{{ret.LeaveScheme!=null?ret.LeaveScheme.Code: 'UnSigned'}}</td>
                                <td class="text-center">{{ret.LeaveSchemeAssignment!=null?$format(ret.LeaveSchemeAssignment.LastUpdated,'DD/MM/YYYY HH:mm A'): ''}}</td>
                                <td class="text-center cell-badge" v-html="$statusLabel(ret.LeaveSchemeAssignment!=null?ret.LeaveSchemeAssignment.Status: '')"></td>
                                <td class="text-center">
                                    <router-link :to="{ name: 'leave_balance',params: { id: ret.Employee.Id }}"><i class="fa fa-eye" aria-hidden="true"></i> View</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit"
                                      v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                      hide-goto-end-buttons
                                      @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
        <b-modal :no-close-on-backdrop="true" :title="$t('leave_apply_scheme')" size="sm" ref="innermodal">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label class="control-label blue">{{$t('name')}}</label>
                        <div>
                            <input type="text" class="form-control form-control-sm" v-model="model.Description" readonly />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label class="control-label blue">{{$t('leave_scheme')}}</label>
                        <div>
                            <select class="form-control form-control-sm" v-model="model.LeaveSchemeId">
                                <option v-for="ret in schemes" :key="ret.id" :value="ret.Id">{{ret.Code + ' : ' + ret.Description }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{ $t("save") }}</b-btn>
            </div>
        </b-modal>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                query: {
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Text: ''
                },
                schemes: [],
                list: [],
                model: {
                    Description: '',
                    EmployeeId: '',
                    LeaveSchemeId: ''
                }
            }
        },
        async created () {
            this.toList();
            await this.schemeList();
        },
        methods: {
            schemeChange(e){
                this.model.Description = e.Employee.Num + ' : ' + e.Employee.KhmerName;
                this.model.EmployeeId = e.Employee.Id;
                this.model.LeaveSchemeId = '';
                if(e.LeaveSchemeAssignment != null){
                    this.model.LeaveSchemeId = e.LeaveSchemeAssignment.LeaveSchemeId
                }
                this.$refs.innermodal.show();
            },
            onSave(){
                let loading = this.$loading.show();
                this.$api().post('scheme/assignment', this.model).then(res => {
                    if (this.$isValid(res)) {
                        this.$refs.innermodal.hide();
                        this.toList();
                    }
                }).finally(function () {
                    loading.hide();
                });
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            toList() {
                let loading = this.$loading.show();
                this.$api().post('scheme/assignments', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.list = res.data.Json.Assignments;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function () {
                    loading.hide();
                });
            },
            async schemeList() {
                var res = await this.$api().post('schemes', { Limit: 0 });
                if (this.$isValid(res)) {
                    this.schemes = res.data.Json.Schemes;
                }
            }
        }
    }
</script>